import { jsx as _jsx } from "react/jsx-runtime";
import SubHeader from '../SubHeader';
import { Routes } from '../../../../constants/routes';
import { useTranslation } from 'react-i18next';
const SocialSubHeader = () => {
    const { t } = useTranslation();
    const navBarProfiles = [
        {
            name: t('friends'),
            link: Routes.FRIENDS,
            disabled: false,
            parent: 'friends'
        },
        {
            name: t('my_guild'),
            link: Routes.MY_GUILD,
            disabled: false,
            parent: ''
        },
        {
            name: t('all_guilds'),
            link: Routes.ALL_GUILD,
            disabled: false,
            parent: ''
        }
    ];
    return _jsx(SubHeader, { data: navBarProfiles });
};
export default SocialSubHeader;
